import request from '@/util/request'

/**
 * 添加分组
 *
 * @param model
 * @returns {*}
 */
export function addGroup(model) {
    return request({
        url: '/api-admin/group',
        method: 'post',
        data: model
    })
}

export function editGroup(model) {
    return request({
        url: '/api-admin/group',
        method: 'put',
        data: model
    })
}

/**
 * 删除分组
 *
 * @param params
 * @returns {*}
 */
export function delGroup(params) {
    return request({
        url: '/api-admin/group/' + params.code,
        method: 'delete',
        query: {}
    })
}

/**
 * 删除分组
 *
 * @param params
 * @returns {*}
 */
export function delGroups(params) {
    return request({
        url: '/api-admin/group',
        method: 'delete',
        data: params
    })
}

/**
 * 分页获取分组
 *
 * @param params
 * @returns {*}
 */
export function pageGroup(params) {
    return request({
        url: '/api-admin/group/page/with_qr_list',
        method: 'post',
        data: params
    })
}

/**
 * 下拉展示分组
 * @param params
 * @returns {*}
 */
export function downListGroup(params) {
    return request({
        url: '/api-admin/group/down_list',
        method: 'post',
        data: params
    })
}

